import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CampaignService } from '@uw/core/services/campaign.service';
import { of, map, mergeMap, catchError } from 'rxjs';
import * as CampaignActions from './campaign.actions';


@Injectable()
export class CampaignEffects {

  loadDonorCampaigns$ = createEffect(() => this.actions$.pipe(
    ofType(CampaignActions.loadDonorCampaigns),
    mergeMap(() => this.campaignService.getDonorActiveCampaignList()
      .pipe(
        map(campaignList => CampaignActions.loadDonorCampaignsSuccess({campaignList})),
        catchError(error => of(CampaignActions.loadDonorCampaignsFailure({error})))
      ))
    )
  );

  constructor(
    private actions$: Actions,
    private campaignService: CampaignService
  ) {}
}
